import React, { useEffect, useState, lazy, Suspense } from "react";
import SEO from "components/SEO";
import * as icon from "../services/icon";
import axios from "axios";
import IllustrationModal from "../components/Modals/IllustrationModal";
import { PLACEHOLDER } from "src/constants/images";

import WalletSkeleton from "../components/Loader/Skeleton/WalletImageSkeleton";

const IllustrationCard = lazy(() =>
  import("../components/IllustrationCard/IllustrationCard")
);

const Gallery = () => {
  useEffect(() => {
    window?.scrollTo(0, 0);
  }, []);

  const pageMetaData = {
    pageTitle: `Illustration Gallery | GangstaBet: A Digital Collectible  `,
    pageDescription: null,
    pageKeywords: null,
    pageImage: null,
  };

  const [totalOwnedIllustrations, settotalOwnedIllustrations] = useState([]);
  const [currentSelectedNFT, setCurrentSelectedNFT] = useState({});
  const [currentSelectedGangstaBet, setCurrentSelectedGangstaBet] = useState(
    {}
  );
  const [isModalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    let isMounted = true;
    
    const fetchIllustrations = async () => {
      try {
        const illustratioReservation = await icon.getReservations();
        const totalOwnedIllustrationsArray = [...totalOwnedIllustrations];

        for await (let illustration of illustratioReservation) {
          if (!isMounted) break; // Check if component is still mounted
          
          if (illustration.minted === "0x1") {
            const token = await icon.getIllustrationTokenURI(illustration.id);
            const { data } = await axios.get(token + ".json");
            totalOwnedIllustrationsArray.push({
              name: data.name,
              image_url: data.image_url,
              id: data.id,
              gangstabet_id: data.gangstabet_id,
            });
          }
        }
        
        if (isMounted) {
          settotalOwnedIllustrations([...totalOwnedIllustrationsArray.reverse()]);
        }
      } catch (error) {
        console.error('Error fetching illustrations:', error);
      }
    };

    fetchIllustrations();

    return () => {
      isMounted = false;
    };
  }, []);

  const GANGSTABET_DETAILS_API = "https://api.gangstabet.io/api/public/token/";

  useEffect(() => {
    let isMounted = true;
    
    const fetchGangstaBetDetails = async () => {
      if (currentSelectedNFT.gangstabet_id) {
        try {
          const res = await axios.get(
            GANGSTABET_DETAILS_API + currentSelectedNFT.gangstabet_id
          );

          let owner_address = await icon.ownerOf(
            "0x" + currentSelectedNFT.gangstabet_id.toString(16)
          );

          let owner_address_illustration = await icon.ownerOfIllustration(
            "0x" + currentSelectedNFT.id.toString(16)
          );

          if (isMounted) {
            setCurrentSelectedGangstaBet({
              ...res.data,
              owner_address: owner_address,
              owner_address_illustration: owner_address_illustration,
            });
          }
        } catch (error) {
          console.error('Error fetching gangsta bet details:', error);
        }
      }
    };

    fetchGangstaBetDetails();

    return () => {
      isMounted = false;
    };
  }, [currentSelectedNFT]);

  return (
    <SEO pageMetaData={pageMetaData}>
      <div className="container crown-container" style={{ minHeight: "25em" }}>
        <h2 className="colorWhite">Illustration Gallery</h2>
        <p>
          GangstaBets reimagined as illustrations, all of these illustrations
          are based on original GangstaBet NFTs, while staying true to their
          style and appeal.
        </p>

        <div className="illustration-list">
          {totalOwnedIllustrations.length == 0 ? (
            <div className="mt-5">
              {" "}
              <WalletSkeleton />
            </div>
          ) : (
            <div className="mt-3 d-flex flex-wrap">
              {" "}
              {totalOwnedIllustrations.map((nft, index) => (
                <Suspense
                  fallback={
                    <div className="image-block position-relative w-100 h-100">
                      <div
                        class="spinner-border position-absolute spinner"
                        role="status"
                      >
                        <span class="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  }
                >
                  <div
                    onClick={() => {
                      setCurrentSelectedNFT({
                        gangstabet_id: nft.gangstabet_id,
                        name: nft.name,
                        image: nft.image_url,
                        id: nft.id,
                      });
                      setModalOpen(true);
                    }}
                  >
                    <IllustrationCard
                      name={nft.name}
                      image={nft.image_url}
                      key={index}
                      gangstabet_id={`GangstaBet #${nft.gangstabet_id}`}
                      id={nft.id}
                    />
                  </div>
                </Suspense>
              ))}
              {[...Array(20 - totalOwnedIllustrations.length)].map((v, i) => (
                <Suspense fallback={<></>}>
                  <IllustrationCard
                    name={`Illustration #${
                      i + totalOwnedIllustrations.length + 1
                    }`}
                    image={PLACEHOLDER}
                    key={i}
                    gangstabet_id="To be revealed soon"
                    id="123"
                  />
                </Suspense>
              ))}
            </div>
          )}
        </div>
      </div>
      {isModalOpen ? (
        <IllustrationModal
          onClose={() => {
            setModalOpen(false);
            setCurrentSelectedNFT({});
            setCurrentSelectedGangstaBet({});
          }}
          isVisible={isModalOpen}
          currentSelectedNFT={currentSelectedNFT}
          currentSelectedGangstaBet={currentSelectedGangstaBet}
        />
      ) : null}
    </SEO>
  );
};

export default Gallery;
